import { UnitsProvider } from 'hooks/units'

const UnitProvider = ({ children }) => {
	return (
		<UnitsProvider>{children}</UnitsProvider>
	)
}

export default UnitProvider
